import React from 'react'
import ActionsModal from 'components/ActionsModal/ActionsModal'

interface DeleteOrganizationModalProps {
  organization: {
    name?: string
    [key: string]: any
  }
  onSubmit: (organization: any) => void | Promise<void>
  onClose: () => void
}

export default function DeleteOrganizationModal({ organization, onSubmit, onClose }: DeleteOrganizationModalProps) {
  return (
    <ActionsModal
      type='organization'
      mode='delete'
      item={organization}
      primaryKey='name'
      fields={{}}
      onFieldChange={() => {}}
      onClose={onClose}
      onSubmit={() => onSubmit(organization)}
    />
  )
}

